import * as signUpClientActions from '../../admin/constants/signUpClient'

const initialState = {
    isFetching: false,
    signUpClientData: {},
    err: null
}

const signUpClientReducer = (state = initialState, action) => {
    switch (action.type) {
        case signUpClientActions.FETCH_SIGN_UP_CLIENT_REQUEST: {
            return {
                isFetching: true,
                signUpClientData: {},
                err: null
            }
        }
        case signUpClientActions.FETCH_SIGN_UP_CLIENT_SUCCESS: {
            return {
                isFetching: false,
                signUpClientData: action.signUpClientData,
                err: null
            }
        }
        case signUpClientActions.FETCH_SIGN_UP_CLIENT_FAILURE: {
            return {
                isFetching: false,
                signUpClientData: {},
                err: action.error
            }
        }

        case signUpClientActions.SIGN_UP_CLIENT_RESET: {
            return initialState
        }

        default:
            return state
    }
}

export default signUpClientReducer
